import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import * as Fathom from 'fathom-client';

import SolanaProvider from '../components/SolanaProvider.js';
import '../styles/globals.css';

export default function AbunaiKeikaku({ Component, pageProps }) {
  const router = useRouter();
  useEffect(() => {
    Fathom.load('AGYQPOZM', {
      includedDomains: ['abunai-keikaku.vercel.app'],
    });
    function onRouteChangeComplete() {
      Fathom.trackPageview();
    }
    // Record a pageview when route changes
    router.events.on('routeChangeComplete', onRouteChangeComplete);
    // Unassign event listener
    return () => {
      router.events.off('routeChangeComplete', onRouteChangeComplete);
    };
  }, [router.events]);

  return (
    <>
      <Head>
        <title>Abunai Keikaku Dragons</title>
        {/*
        <Meta />
        */}
      </Head>
      <SolanaProvider>
        <Component {...pageProps} />
      </SolanaProvider>
    </>
  );
}
